import { render, staticRenderFns } from "./ruleDialog.vue?vue&type=template&id=4e67233a&scoped=true"
import script from "./ruleDialog.vue?vue&type=script&lang=js"
export * from "./ruleDialog.vue?vue&type=script&lang=js"
import style0 from "./ruleDialog.vue?vue&type=style&index=0&id=4e67233a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67233a",
  null
  
)

export default component.exports